import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-05658f40")

_pushScopeId("data-v-05658f40")
const _hoisted_1 = { class: "property-container inline" }
const _hoisted_2 = { class: "entity-container inline" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_VirtualLink = _resolveComponent("VirtualLink")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.value, (one, index) => {
        return (_openBlock(), _createBlock(_Fragment, {
          key: one.EntityId
        }, [
          (one[_ctx.propertyToShow]?.length > 0 || one?.Title?.length > 0)
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                (_ctx.link)
                  ? (_openBlock(), _createBlock(_component_VirtualLink, {
                      key: 0,
                      href: one[_ctx.linkProperty ?? _ctx.Sefurl],
                      class: _ctx.classList
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(one[_ctx.propertyToShow ?? 'Title']), 1),
                        (index < _ctx.value.length-1)
                          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_ctx.charaterDelimited), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["href", "class"]))
                  : (_ctx.hasHtml)
                    ? (_openBlock(), _createBlock("span", {
                        key: 1,
                        innerHTML: one[_ctx.propertyToShow ?? 'Title'],
                        class: _ctx.classList
                      }, null, 10, ["innerHTML"]))
                    : (_openBlock(), _createBlock("span", {
                        key: 2,
                        class: _ctx.classList
                      }, [
                        _createTextVNode(_toDisplayString(one[_ctx.propertyToShow ?? 'Title']), 1),
                        (index < _ctx.value.length-1)
                          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_ctx.charaterDelimited), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 2))
              ], 64))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ])
  ]))
})